
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import WarehousesListView from "./warehouses-list.html";
import WarehousesEditView from "./warehouses-edit.html";

angular.module("warehouses", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('warehouses', {
                url: "/warehouses",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('warehouses.list', {
                url: "/list",
                controller: "WarehousesListCtrl",
                template: WarehousesListView,
                data: { pageTitle: 'Almacenes' },
                requiredPermission: ["WAREHOUSES_READ"]
            })
            .state('warehouses.edit', {
                url: "/edit/:id",
                controller: "WarehousesEditCtrl",
                template: WarehousesEditView,
                data: { pageTitle: 'Almacenes' },
                requiredPermission: ["WAREHOUSES_READ"]
            })
    }])
    ;